module.exports = __webpack_public_path__ + "img/Question-bg-6.a19d771a.png";